var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 8C22.17 8 23.0654 8.89543 23.0654 10V14C23.0654 15.1046 22.17 16 21.0654 16H20.0035C19.5114 19.9463 16.145 23 12.0654 23V21C15.3791 21 18.0654 18.3137 18.0654 15V9C18.0654 5.68629 15.3791 3 12.0654 3C8.75172 3 6.06543 5.68629 6.06543 9V16H3.06543C1.96086 16 1.06543 15.1046 1.06543 14V10C1.06543 8.89543 1.96086 8 3.06543 8H4.12732C4.61942 4.05369 7.98581 1 12.0654 1C16.145 1 19.5114 4.05369 20.0035 8H21.0654ZM7.82487 15.7849L8.88501 14.0887C9.80704 14.6662 10.8972 15 12.0654 15C13.2336 15 14.3238 14.6662 15.2458 14.0887L16.306 15.7849C15.0766 16.5549 13.623 17 12.0654 17C10.5078 17 9.05425 16.5549 7.82487 15.7849Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/Contactus.7014cba9564d818d4cbaafbdd3e0eeaa.svg";
export { ForwardRef as ReactComponent };